import { Usage, UsageQuota } from '@/types/index.d'

function reduceReferralQuotas(
  usage: Usage,
  allowance_limit_type?: 'REVISION_SCAN' | 'PR_SCAN'
) {
  return usage?.quotas
    ?.filter(isReferralAllowanceQuota)
    .reduce((acc, quota: UsageQuota) => {
      if (
        allowance_limit_type &&
        quota.allowance_limit_type !== allowance_limit_type
      ) {
        // if the allowance_limit_type is defined but does not match do not consider this allowance
        return acc
      }
      acc[quota.type] = Number.isFinite(acc[quota.type])
        ? acc[quota.type] + quota.current_value
        : quota.current_value
      return acc
    }, {})
}

function calculateCumulativeRemainingAllowance(
  usage: Usage,
  allowance_limit_type?: 'REVISION_SCAN' | 'PR_SCAN'
): {
  cumulative: number
  renewable: number
  referral: number
} {
  const cumulativeQuotas = reduceReferralQuotas(usage, allowance_limit_type)
  if (
    !cumulativeQuotas ||
    !Number.isFinite(cumulativeQuotas['ALLOWANCE_RENEWABLE']) ||
    !Number.isFinite(cumulativeQuotas['ALLOWANCE_REFERRAL'])
  ) {
    return {
      cumulative: NaN,
      renewable: NaN,
      referral: NaN,
    }
  }

  const renewable = cumulativeQuotas['ALLOWANCE_RENEWABLE']
  const referral = cumulativeQuotas['ALLOWANCE_REFERRAL']
  const cumulative = renewable + referral
  return {
    cumulative,
    renewable,
    referral,
  }
}

function isReferralAllowanceQuota(quota: UsageQuota): boolean {
  return (
    quota?.type === 'ALLOWANCE_RENEWABLE' ||
    quota?.type === 'ALLOWANCE_REFERRAL'
  )
}

export {
  calculateCumulativeRemainingAllowance,
  isReferralAllowanceQuota,
  reduceReferralQuotas,
}
